import React from 'react'
import styled from 'styled-components'
import { FavouriteLeadsDataTable } from '../../Components/Telesales/Telesaleleads/Telesalefavouriteleads/FavouriteLeadsDataTable'
import { colors } from '../../Shared/colors'

export const FavouriteLeadsComponent = () => {
  return (
    <Main>
        <FavouriteLeadsDataTable/>
    </Main>
  )
}

const Main = styled.div`
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.inputWhite} 100%);
  min-height: 100vh;
  padding: 1rem 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
`

